import { RolesEnum } from 'core/models';

export const isAdmin = (user: any = {}) => {
  return (
    user?.roles?.findIndex((item: Record<string, any>) =>
      [
        RolesEnum.SiteAdmin,
        RolesEnum.SuperAdmin,
        RolesEnum.TenantAdmin,
        RolesEnum.ProgramManager,
      ].includes(item.name),
    ) !== -1
  );
};

export const isEC = (user: any = {}) => {
  return (
    user?.roles?.findIndex((item: Record<string, any>) =>
      [RolesEnum.EnrollmentCoordinator].includes(item.name),
    ) !== -1
  );
};

export const isAdminWithOutPM = (user: any = {}) => {
  return (
    user?.roles?.findIndex((item: Record<string, any>) =>
      [
        RolesEnum.SiteAdmin,
        RolesEnum.SuperAdmin,
        RolesEnum.TenantAdmin,
      ].includes(item.name),
    ) !== -1
  );
};

export const isSuperAdmin = (user: any = {}) => {
  const index = user?.roles?.findIndex((item: Record<string, any>) =>
    [
      RolesEnum.SuperAdmin,
      RolesEnum.TenantAdmin,
      RolesEnum.ProgramManager,
      RolesEnum.VivaLNKAdmin,
    ].includes(item.name),
  );
  return index !== -1;
};

export const isProgramManager = (user: any = {}) => {
  return (
    user?.roles?.findIndex(
      (item: Record<string, any>) => item.name === RolesEnum.ProgramManager,
    ) !== -1
  );
};

export const isAnalyst = (user: any = {}) => {
  return (
    user?.roles?.findIndex(
      (item: Record<string, any>) => item.name === RolesEnum.Analyst,
    ) !== -1
  );
};

export const notifyMfaSuccess = (accessToken: string, refreshToken: string) => {
  console.log('start VivaAIWebView', window?.VivaAIWebView);
  if (
    window?.VivaAIWebView &&
    typeof window.VivaAIWebView.returnToken === 'function'
  ) {
    console.log('handle window.VivaAIWebView.returnToken');
    return window.VivaAIWebView.returnToken({
      type: 'token',
      accessToken,
      refreshToken,
      close: true,
    });
  }

  console.warn('VivaAIWebView.returnToken is not available');
  return false;
};

export const getVivalinkSsoCookie = (name: string) =>
  document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split(`${name}=`)[1];

export const showPROs = (user: any) => {
  return user?.tenant?.eq5d5lEnabled;
};

export default {};
